import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "bold",
  "use": "bold-usage",
  "viewBox": "0 0 11 12",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 11 12\" id=\"bold\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M.333.667C.333.298.632 0 1 0h5.333a3.333 3.333 0 110 6.667H1A.667.667 0 01.333 6V.667zm1.334.666v4h4.666a2 2 0 100-4H1.667z\" fill=\"#000\" /><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M.333 6c0-.368.299-.667.667-.667h6A3.333 3.333 0 017 12H1a.667.667 0 01-.667-.667V6zm1.334.667v4H7a2 2 0 100-4H1.667z\" fill=\"#000\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol